export default __webpack_public_path__ + "static/media/close.344c73ed.svg";